import React from "react";
import servicesData from "../utils/servicesData";
import "./Services.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Services() {
  return (
    <section id ="services" className="services-section container-fluid py-5">
      <div className="text-center mb-5">
        <h2 className="section-title">What We Do</h2>
        <p className="section-subtitle">
          At EZ MedServ, we provide a 360° portfolio of services designed to meet the needs of modern businesses:
        </p>
      </div>
      <div className="container">
      <div className="row g-4">
        {servicesData.map((service, index) => (
          <div key={index} className="col-12 col-md-6 col-lg-3">
            <div className="service-card p-4 h-100">
              <h5 className="text-center">
                <div className="service-icon mb-2">
                    <FontAwesomeIcon icon={service.icon} />
                </div>
                <div className="service-title">
                {service.title}
                </div>
              </h5>
              <ul className="service-points">
                {service.points.map((point, idx) => (
                  <li key={idx}>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
      </div>
    </section>
  );
}

export default Services;